import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    // Source'ları data attribute içinden gerçek src'ye yaz
    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) source.setAttribute('src', videoSource);
    }

    // Mobil autoplay için kritik ayarlar
    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('autoplay', '');
    videoElement.setAttribute('loop', '');

    // iOS Safari için ek güvence
    videoElement.playsInline = true;

    // Yükle ve oynatmayı zorla
    videoElement.load();

    const tryPlay = () => {
      const playPromise = videoElement.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          // Bazı mobil tarayıcılarda ilk deneme başarısız olabilir.
          // Sessizce bırakıyoruz; kullanıcı etkileşimi sonrası oynar.
        });
      }
    };

    // Metadata gelince bir daha dene (Safari için daha stabil)
    if (videoElement.readyState >= 2) {
      tryPlay();
    } else {
      videoElement.addEventListener('loadedmetadata', tryPlay, { once: true });
      videoElement.addEventListener('canplay', tryPlay, { once: true });
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}